<p-confirmDialog [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>

<!--Menu Bar-->
<div class="lock-to-top" style="background-color: #ffffff">
	<div class="InfoText" *ngIf="DataChanged == true">
		<h4>* Data has been changed</h4>
	</div>

	<div class="selector-item">
		<div>
			<label>School</label>
		</div>

		<div style="margin-left: 10px">
			<!-- Note: (ngModelChange) must go after [(ngModel)] or you get prev selected item!  -->
			<!-- <select class="form-control" name="SchoolSelector" style="font-size:smaller;"
                [(ngModel)]="SchoolID"
                (ngModelChange)="onSchoolChange($event)">
                <option *ngFor="let r of lstSchool" [ngValue]="r.SchoolID">[{{r.SchoolNumber}}] - {{r.SchoolName}}</option>
            </select> -->

			<caass-schoolselector [ShowAll]="false" [Disabled]="IsLoading()"> </caass-schoolselector>
		</div>
	</div>

	<!--Buttons-->
	<div class="button-body flex">
		<button [disabled]="IsLoading() == true" class="btn btn-primary" style="margin-left: 0px" (click)="onRefresh()">Refresh</button>

		<!--INSERT CUSTOM BUTTONS HERE-->
		<button [disabled]="IsLoading() == true" class="btn btn-primary" style="margin-left: 5px" (click)="onUpdateCourse()">Update</button>
	</div>
</div>

<!--Table-->
<div class="table-main-body">
	<p-table
		#mydt
		[value]="lstCourse"
		[loading]="IsLoading() == true"
		[paginator]="true"
		[(rows)]="pagerows"
		[(first)]="pagefirst"
		[showCurrentPageReport]="true"
		[resizableColumns]="false"
		sortMode="multiple"
		styleClass="p-datatable-striped"
		selectionMode="single"
		[(selection)]="SelectedCourse"
		dataKey="CourseID"
		(onFilter)="onHandleFilter($event)"
		(onSort)="onHandleSort($event)"
		(onRowSelect)="onRowSelect($event)"
		(onRowUnselect)="onRowUnselect($event)"
		currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
		[rowsPerPageOptions]="[5, 10, 25, 50]"
	>
		<!--Headers-->
		<ng-template pTemplate="header">
			<!--Filter or Select from Dropdown-->
			<tr>
				<!--INSERT CUSTOM FILTERS HERE-->

				<!--CourseNo-->
				<th>
					<p-columnFilter type="text" field="CourseNo" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--CourseDesc-->
				<th>
					<p-columnFilter type="text" field="CourseDesc" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--CourseCD-->
				<th>
					<p-columnFilter type="text" field="CourseCD" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--DepartmentDesc-->
				<th>
					<p-columnFilter field="DepartmentDesc" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterDepartmentDesc
								[ngModel]="value"
								[options]="lstDepartmentDesc"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>

				<!--CourseType-->
				<th>
					<p-columnFilter field="CourseTypeID" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterCourseType
								[ngModel]="value"
								[options]="lstCourseType"
								optionValue="CourseTypeID"
								optionLabel="CourseTypeDesc"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value.CourseTypeDesc }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>
			</tr>

			<!--Column Names-->
			<tr style="height: 4rem">
				<!--INSERT CUSTOM COLUMNS HERE-->
				<th pSortableColumn="CourseNo">Course Number<p-sortIcon field="CourseNo"></p-sortIcon></th>
				<th pSortableColumn="CourseDesc">Description<p-sortIcon field="CourseDesc"></p-sortIcon></th>
				<th pSortableColumn="CourseCD">Code<p-sortIcon field="CourseCD"></p-sortIcon></th>
				<th pSortableColumn="DepartmentDesc">Department<p-sortIcon field="DepartmentDesc"></p-sortIcon></th>
				<th pSortableColumn="CourseTypeID">Type<p-sortIcon field="CourseTypeID"></p-sortIcon></th>
			</tr>
		</ng-template>

		<!--Data-->
		<ng-template pTemplate="body" let-Course>
			<tr [pSelectableRow]="Course">
				<td *ngFor="let col of cols" style="font-weight: bold">
					{{ Course[col.field] }}
				</td>

				<td>
					<select class="form-control" [(ngModel)]="Course.CourseTypeID" (ngModelChange)="onCourseTypeChange(Course, $event)">
						<option value="" style="display: none"></option>
						<option *ngFor="let o of CourseTypeList" [ngValue]="o.CourseTypeID">
							{{ o.CourseTypeDesc }}
						</option>
					</select>
				</td>
			</tr>
		</ng-template>
	</p-table>
</div>

<!--Error Message-->
<div class="TopMargin">
	<div name="errorMessage" *ngIf="errorMessage" class="alert alert-danger">
		{{ errorMessage }}
	</div>
</div>
